import { render, staticRenderFns } from "./MutationsTable.vue?vue&type=template&id=6a1d7b03&"
import script from "./MutationsTable.vue?vue&type=script&lang=js&"
export * from "./MutationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports